import { init as initApm, apm } from '@elastic/apm-rum';
import { version } from '../../../../../package.json';

export default class ElasticAdapter {
  init() {
    initApm({
      serviceName: process.env.REACT_APP_ELASTIC_APM_SERVICE_NAME,
      serverUrl: process.env.REACT_APP_ELASTIC_APM_SERVER_URL,
      environment: process.env.REACT_APP_ELASTIC_APM_ENVIRONMENT,
      serviceVersion: version,
    });
  }

  captureException(transactionName, severityLevel, error, details) {
    if (details) {
      apm.addLabels({ errorDetails: details });
    }
    apm.captureError(error);
  }

  captureLog(message, severityLevel, details) {
    apm.captureError(message, details);
  }

  captureUIException(error, { componentStack }) {
    apm.addLabels({ componentStack: JSON.stringify(componentStack) });
    apm.captureError(error);
  }
}



// WEBPACK FOOTER //
// ./src/utils/errorLogger/adapters/Elastic/index.js